import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import CompulsaryCandidateProfile from "./CompulsaryCandidateProfile";

const CompulsaryProfile = () => {
  const profile = useSelector((state) => state.customer?.profile);

  const profileData = profile?.data?.data ?? profile?.data;
  const rawType = profileData?.customerType ?? profileData?.customer_type;
  const customerType =
    rawType === null || rawType === undefined || rawType === ""
      ? null
      : Number(rawType);

  // Employers never see this page.
  if (customerType === 1) {
    return <Navigate to="/employer/dashboard" replace />;
  }

  if (customerType === 0) {
    return <CompulsaryCandidateProfile />;
  }

  return (
    <div className="container py-5 text-center">
      <div className="spinner-border text-primary" role="status" />
      <p className="mt-3">Loading profile...</p>
    </div>
  );
};

export default CompulsaryProfile;